(function() {
    'use strict';
    
    window.onload =  formValidation();
    
    function formValidation() {
        var form = document.querySelectorAll('.needs-validation');
        
        if (form.length > 0) {
            form.forEach(function (form) {
                form.addEventListener('submit', validateSubmit);
                for (var i = 0, element; element = form.elements[i++];) {
                    if (element.required === true) {
                        if (element.type === 'text') {
                            element.addEventListener('blur', validateTextFields);
                        } else if (element.type === 'email') {
                            element.addEventListener('blur', validateEmailFields);
                        } else if (element.type === 'tel') {
                            element.addEventListener('blur', validateTelFields);
                        } else if (element.tagName === 'SELECT') {
                            element.addEventListener('change', validateSelectFields);
                        } else if (element.tagName === 'TEXTAREA') {
                            element.addEventListener('blur', validateTextareaFields);
                        }
                    }        
                }
            });
        }
    }
    
    function validateTextFields() {
        if (this.value === '') {
            this.classList.add('is-invalid');
            this.classList.remove('is-valid');
            return false;
        } else {
            this.classList.add('is-valid');
            this.classList.remove('is-invalid');
            return true;
        }
    }
    
    function validateEmailFields() {
        if (this.value === '') {
            this.classList.add('is-invalid');
            this.classList.remove('is-valid');
            return false;
        } else {
            var emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
            if(!this.value.match(emailRegex))
            {
                this.classList.add('is-invalid');
                this.classList.remove('is-valid');
                return false;
            } else {
                this.classList.add('is-valid');
                this.classList.remove('is-invalid');
                return true;
            }
        }
    }
    
    function validateTelFields() {
        if (this.value === '') {
            this.classList.add('is-invalid');
            this.classList.remove('is-valid');
            return false;
        } else {
            var phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
            if (!this.value.match(phoneRegex)) {
                this.classList.add('is-invalid');
                this.classList.remove('is-valid');
                return false;
            } else {
                this.classList.add('is-valid');
                this.classList.remove('is-invalid');
                return true;
            }
        }
    }
    
    function validateSelectFields() {
        if (this.value === '') {
            this.classList.add('is-invalid');
            this.classList.remove('is-valid');
            return false;
        } else {
            this.classList.add('is-valid');
            this.classList.remove('is-invalid');
            return true;
        }
    }
    
    function validateTextareaFields() {
        if (this.value === '') {
            this.classList.add('is-invalid');
            this.classList.remove('is-valid');
            return false;
        } else {
            this.classList.add('is-valid');
            this.classList.remove('is-invalid');
            return true;
        }
    }
    
    function validateSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.checkValidity() === false) {
            this.classList.add('needs-validation');
            this.classList.remove('was-validated');
            for (var i = 0, element; element = this.elements[i++];) {
                if (element.required === true) {
                    if (element.value === '') {
                        element.classList.add('is-invalid');
                    }
                }
            }
            smoothScroll(document.querySelector('.is-invalid').id);
        } else {
            this.classList.add('was-validated');
            this.classList.remove('needs-validation');
            grecaptcha.execute();
        }
    }

    function currentYPosition() {
        // Firefox, Chrome, Opera, Safari
        if (self.pageYOffset) {
            return self.pageYOffset;
        }
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop) {
            return document.documentElement.scrollTop;
        }
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) {
            return document.body.scrollTop;
        }
        return 0;
    }

    function elYPosition(eID) {
        var elm = document.getElementById(eID);
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
            node = node.offsetParent;
            y += node.offsetTop;
        } return y;
    }

    function smoothScroll(eID) {
        var startY = currentYPosition();
        var stopY = elYPosition(eID) - 32;
        var distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollTo(0, stopY); return;
        }
        var speed = Math.round(distance / 100);
        if (speed >= 20) speed = 20;
        var step = Math.round(distance / 25);
        var leapY = stopY > startY ? startY + step : startY - step;
        var timer = 0;
        if (stopY > startY) {
            for ( var i=startY; i<stopY; i+=step ) {
                setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
                leapY += step; if (leapY > stopY) leapY = stopY; timer++;
            } return;
        }
        for ( var i=startY; i>stopY; i-=step ) {
            setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
            leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
        }
    }
})();